import { createI18n } from 'vue-i18n';

const localeCtx = import.meta.glob('@/lang/**/*.json', { eager: true });
const messages = Object.fromEntries(
  Object.entries(localeCtx).map(([path, module]) => {
    const locale = path.replace(/.*\/([\w-]+)\.json$/, '$1');
    return [locale, (module as any).default];
  })
);

// locale apply order
// 1. <html lang>
// 2. Browser language
// 3. "ja"

const i18n = createI18n({
  // ref: https://vue-i18n.intlify.dev/guide/advanced/composition.html#basic-usage
  legacy: false, // you must set `false`, to use Composition API
  locale: document.documentElement.lang,
  fallbackLocale: [
    navigator.language,
    'ja',
  ],
  silentFallbackWarn: true,
  messages,
});

export function loadLocaleMessages (locale: string) {
  document.documentElement.lang = locale;
  i18n.global.locale.value = locale;
}

export default i18n;
